import { render, staticRenderFns } from "./ModalProductAdd.vue?vue&type=template&id=47e9f41c&"
import script from "./ModalProductAdd.vue?vue&type=script&lang=js&"
export * from "./ModalProductAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports